@defer (when !loading()) {
<section >
  <div class="main-input" >
    <div class="headline-area-summary">
      <h1>Join 360</h1>
      <div class="hyphen"></div>
      <h3>Key Metrics at Glance</h3>
    </div>

    <div class="headline-area-summary-mobile">
      <h1>Join 360</h1>
      <h3>Key Metrics at Glance</h3>
      <div class="hyphen-mobile"></div>
    </div>

    <div class="menu-summary" [routerLink]="'/board'">

      <div class="to-do-done">
        <div class="menu-point">
          <div class="to-do-icon"></div>
          <div class="category-number-container">
            <p>{{todoCount}}</p>
            <span class="text-input">To-do</span>
          </div>
        </div>

        <div class="menu-point">
          <div class="done-icon"></div>
          <div class="category-number-container">
            <p>{{doneCount}}</p>
            <span class="text-input">Done</span>
          </div>
        </div>
      </div>

      <div class="deadline-priority-container">
        <div class="deadline-priority">
          <div class="priority">
            <img src="assets/img/summary/urgentDefaultIcon.png">
            <div class="category-number-container">
              <p>{{urgentCount}}</p>
              <span class="text-input">Urgent</span>
            </div>
          </div>

          <div class="hyphen"></div>
          <div class="deadline">
            <span id="date">{{nextDeadline}}</span>
            <span id="deadline">Upcoming Deadline</span>
          </div>
        </div>
      </div>


      <div class="progression-tasks">
        <div class="hover-container">
          <div class="small-menu-point">
            <h4>{{ boardService.taskList.length }}</h4>
            <span class="text-input">Tasks in <br> Board</span>
          </div>
        </div>

        <div class="hover-container">
          <div class="small-menu-point">
            <h4>{{progressCount}}</h4>
            <span class="text-input">Tasks in <br> Progress</span>
          </div>
        </div>

        <div class="hover-container">
          <div class="small-menu-point">
            <h4>{{feedbackCount}}</h4>
            <span class="text-input">Awaiting <br> Feedback</span>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="user-greeting">
    <h2>{{currentGreeting()}}</h2>
    <br> <span id="username">{{userFullName}}</span>
  </div>
</section>
}
@placeholder {
  <div class="loader-overlay">
    <div class="three-dots-loader">
      <h2>{{ currentGreeting() }}</h2> 
      <span>{{userFullName}}</span>
    </div>
  </div>

}

